import { graphql } from '@/gql';
import type { AddServiceAccountGiftCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addServiceAccountGiftCredits = async ({ email, code }: AddServiceAccountGiftCreditsMutationVariables): Promise<number> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddServiceAccountGiftCredits($email: String!, $code: String!) {
        addServiceAccountGiftCredits(email: $email, code: $code)
      }
    `),
    variables: {
      email,
      code,
    },
  });

  return response.data?.addServiceAccountGiftCredits!;
};
